import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

const index = props => {
  const { offerCode } = props;

  return (<div className="CarItemPreview">
      <a href={`/offers/${offerCode}`} target="_blank" aria-label={'Dettaglio Offerta'}>
        Vedi dettaglio offerta <i className="os-icon os-icon-external-link"/>
      </a>
    </div>
  );
}

index.propTypes = {
  offerCode: PropTypes.string.isRequired,
};

export default index;
